module.exports = __webpack_public_path__ + "static/img/4.955de57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pczhongfu/4.png
// module id = iE3j
// module chunks = 0